module.exports = __webpack_public_path__ + "img/groupModeOff.dfb380a4.svg";